import { formListCreatedAt, isFormListItemClosed } from "./formMeta";
import type { FormListItemDto } from "../../types/formList";
import type {
  FormsListSortBy,
  FormsListSortDir,
} from "../admin/formsListPreferences";

function parseCreatedAt(value?: string): number {
  if (!value) return 0;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
}

/** Дата для сортировки; без даты — id (новые yandex-зеркала имеют больший id). */
function formListSortTimestamp(form: FormListItemDto): number {
  const parsed = parseCreatedAt(formListCreatedAt(form));
  return parsed !== 0 ? parsed : form.id;
}

export function sortFormsList(
  forms: FormListItemDto[],
  sortBy: FormsListSortBy,
  sortDir: FormsListSortDir,
): FormListItemDto[] {
  const direction = sortDir === "asc" ? 1 : -1;

  return [...forms].sort((left, right) => {
    let compare = 0;

    switch (sortBy) {
      case "name":
        compare = left.name.localeCompare(right.name, "ru");
        break;
      case "id":
        compare = left.id - right.id;
        break;
      case "status": {
        const leftClosed = isFormListItemClosed(left) ? 1 : 0;
        const rightClosed = isFormListItemClosed(right) ? 1 : 0;
        compare = leftClosed - rightClosed;
        break;
      }
      case "createdAt":
      default:
        compare = formListSortTimestamp(left) - formListSortTimestamp(right);
        break;
    }

    if (compare === 0) {
      compare = left.id - right.id;
    }

    return compare * direction;
  });
}
